import { apiBase } from 'functions/server/apiBase';
import { getAuthToken } from 'functions/server/authToken';
import { parseBackendError, friendlyBackendMessage } from 'functions/server/backendError';
import { recordRequestFailure } from 'functions/server/requestFailure';


async function generic_backend_request_get(route) {
    /**
     * Sends a GET request to the backend at `route` and returns the `data` field
     * of the standard {success, data, error} envelope.
     *
     * The GET counterpart to generic_backend_request_post, for cacheable public
     * reads like GET /plans (an immutable catalog the gateway/browser can cache).
     * There is no request body. A Clerk bearer token is attached when the user is
     * signed in — harmless on public routes, and consistent with the POST helper.
     * Error handling mirrors the POST helper exactly.
     */
    const headers = {};
    const token = await getAuthToken();
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    if (route.startsWith('/')) {
        route = route.replace('/', '');
    }
    // Same as the POST helper: a rejected fetch has no HTTP status, and was
    // invisible to the telemetry. Status 0 means "no response".
    let response;
    try {
        response = await fetch(apiBase() + '/' + route, { method: 'GET', headers });
    } catch (networkError) {
        recordRequestFailure(route, 0, 'NETWORK_ERROR', 'GET');
        throw networkError;
    }
    if (!response.ok) {
        let body = null;
        try {
            body = await response.json();
        } catch (e) {
            // Not JSON (a gateway HTML page, an empty body). parseBackendError
            // falls back to the status line.
        }
        const { code, message, details } = parseBackendError(body, response.status, response.statusText);
        const error = new Error(friendlyBackendMessage({ code, message, status: response.status, details }));
        error.code = code;
        error.status = response.status;
        error.backendMessage = message;
        error.details = details;
        error.route = route;
        recordRequestFailure(route, response.status, code, 'GET');
        throw error;
    }
    const retJson = await response.json();
    return retJson.data;
}

export default generic_backend_request_get
